import React from 'react';

const WhoWeServeSection = () => {
  return (
    <section data-screen-label="Who we serve" style={{ padding: 'clamp(40px, 4.5vw, 64px) clamp(16px, 4vw, 48px)', background: '#FBFAF6', textAlign: 'left' }}>
      <div
        className="whowe-grid"
        style={{
          maxWidth: '1120px',
          margin: '0 auto',
          alignItems: 'center',
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <span
            style={{
              alignSelf: 'flex-start',
              fontSize: '11px',
              fontWeight: 800,
              letterSpacing: '2px',
              color: '#B5652E',
              border: '1px solid #E1C6A3',
              borderRadius: '999px',
              padding: '5px 14px',
            }}
          >
            WHO WE SERVE
          </span>
          <h2
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: 'clamp(22px, 4vw, 32px)',
              color: '#26332C',
              margin: 0,
              fontWeight: 800,
            }}
          >
            Private Tax Consulting for UAE Businesses
          </h2>
          <p style={{ margin: 0, fontSize: '15.5px', lineHeight: '1.7', color: '#5C574C' }}>
            We work with SMEs, startups, and established companies across Dubai and the wider UAE — mainland and free zone alike. Our role is advisory and preparation: we assess, prepare, and review; all submissions are made by you or your authorized signatory through the relevant government portals.
          </p>
          <ul
            style={{
              listStyle: 'none',
              margin: 0,
              padding: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              fontSize: '14.5px',
              fontWeight: 600,
              color: '#26332C',
            }}
          >
            <li style={{ display: 'flex', gap: '10px' }}>
              <span style={{ color: '#B5652E' }}>◆</span>SMEs &amp; family businesses getting corporate-tax ready
            </li>
            <li style={{ display: 'flex', gap: '10px' }}>
              <span style={{ color: '#B5652E' }}>◆</span>Startups needing eligibility &amp; exemption clarity
            </li>
            <li style={{ display: 'flex', gap: '10px' }}>
              <span style={{ color: '#B5652E' }}>◆</span>Established firms outsourcing tax computation &amp; review
            </li>
            <li style={{ display: 'flex', gap: '10px' }}>
              <span style={{ color: '#B5652E' }}>◆</span>Finance teams wanting a second set of certified eyes
            </li>
          </ul>
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '18px' }}>
          <div style={{ background: '#F3F0E7', borderRadius: '14px', padding: '28px 22px', textAlign: 'center' }}>
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '32px', fontWeight: 800, color: '#26332C' }}>
              25+
            </div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#5C574C' }}>
              Years in UAE tax &amp; audit
            </div>
          </div>
          <div style={{ background: '#F3F0E7', borderRadius: '14px', padding: '28px 22px', textAlign: 'center' }}>
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '32px', fontWeight: 800, color: '#26332C' }}>
              500+
            </div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#5C574C' }}>
              Businesses advised
            </div>
          </div>
          <div style={{ background: '#F3F0E7', borderRadius: '14px', padding: '28px 22px', textAlign: 'center' }}>
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '32px', fontWeight: 800, color: '#26332C', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '2px' }}>
              4.9<span style={{ color: '#B5652E' }}>★</span>
            </div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#5C574C' }}>
              Google rating
            </div>
          </div>
          <div style={{ background: '#F3F0E7', borderRadius: '14px', padding: '28px 22px', textAlign: 'center' }}>
            <div style={{ fontFamily: "'Montserrat', sans-serif", fontSize: '32px', fontWeight: 800, color: '#26332C' }}>
              CA
            </div>
            <div style={{ fontSize: '13px', fontWeight: 600, color: '#5C574C' }}>
              Certified professionals
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhoWeServeSection;
